import {
    DELETE_TEMPLATE,
    DELETE_TEMPLATE_SUCCESS,
    DELETE_TEMPLATE_FAILURE,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    statusMessage: '',
    statusCode: '',
};

const DeleteTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_TEMPLATE:
            return {
                ...state,
                loading: true,
                statusCode: '',
            };
        case DELETE_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                statusMessage: action.payload.statusMessage,
                statusCode: action.payload.statusCode,
            };
        case DELETE_TEMPLATE_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default DeleteTemplateReducer;
